import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { FormattedDate } from '../../components'
import { ROMANEIOS } from '../../navigation/constants'

// The order detail's romaneios (the carrier handover documents its boxes are in, or left in), as
// the platform lists them: each opens on the romaneios page, and its PDF once generated. An order
// dispatched before romaneios existed has none, and the row is not shown.
export const OrderRomaneios = ({ dispatches, warehouseId }) => {
  const { i18n } = useTranslation()
  if (!dispatches?.length) return null

  return (
    <div className="even:bg-gray-50 bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6" data-testid="order-romaneios">
      <dt className="text-base font-medium text-gray-500">{i18n.t('orders.order_details.romaneios')}</dt>
      <dd className="mt-1 text-base text-gray-900 sm:mt-0 sm:col-span-2 flex flex-col gap-1">
        {dispatches.map(dispatch => (
          <div key={dispatch.id}>
            <Link
              to={`${ROMANEIOS.replace(':warehouse_id', warehouseId)}?number=${encodeURIComponent(dispatch.number)}`}
              className="text-indigo-600 hover:text-indigo-800 underline"
            >
              {dispatch.number}
            </Link>
            <span className="text-gray-500 text-sm">
              {' · '}
              {dispatch.carrier_name}
              {' · '}
              {dispatch.status === 'open' ? i18n.t('romaneios.statuses.open') : <FormattedDate date={dispatch.picked_up_at} shortDate={true} />}
            </span>
            {dispatch.document_url && (
              <a
                href={dispatch.document_url}
                target="_blank"
                rel="noopener noreferrer"
                className="ml-2 text-sm text-indigo-600 hover:text-indigo-800 underline"
              >
                {i18n.t('romaneios.document')}
              </a>
            )}
          </div>
        ))}
      </dd>
    </div>
  )
}
